module.exports = __webpack_public_path__ + "img/dm.d7f19301.svg";